export default "__VITE_ASSET__BgV52Kjy__"